import { CheckLegalEntityFieldUniquenessUseCase } from './CheckLegalEntityFieldUniquenessUseCase'

export const checkLegalEntityFieldUniquenessUseCase =
  new CheckLegalEntityFieldUniquenessUseCase().execute
